import Transaction from '@/models/Transaction'
import User from '@/models/User'

export default class TransactionPolicy {
	viewAny(_user: User): boolean {
		return false
	}

	view(_user: User, _transaction: Transaction): boolean {
		return false
	}

	create(_user: User): boolean {
		return false
	}

	update(_user: User, _transaction: Transaction): boolean {
		return false
	}

	restore(_user: User, _transaction: Transaction): boolean {
		return false
	}

	delete(_user: User, _transaction: Transaction): boolean {
		return false
	}

	forceDelete(_user: User, _transaction: Transaction): boolean {
		return false
	}
}
